
import { Component, Vue, Prop } from "vue-property-decorator";

@Component({
  props: ["toggle", "open"],
})
export default class AdminMenuMobile extends Vue {
  adminRoles: any = [];
  isReinsurer = true;

  async mounted() {
    if (this.$store.state.token) {
      await this.loadAdminRoles();
      this.isReinsurer =
        this.$store.state.user.type == this.adminRoles.REASEGURADOR;
    }
  }

  async loadAdminRoles() {
    if (this.$store.state.token) {
      const response: any = await (this.$root as any)._get("admins/getroles");
      this.adminRoles = response;
    }
  }
}
